import React, { useEffect, useState } from 'react';
import Select, { components } from 'react-select';

const controlStyles = {
    borderRadius: '1px solid black',
    color: 'white',
};

const ControlComponent = (props) => (
    <div style={controlStyles}>
        <components.Control {...props} />
    </div>
);

const FactoryDropdown = ({ getFactory, factoryID, factory}) => {
    const [factorySelect, setFactorySelect] = useState([]);
    const [selectedOption, setSelectedOption] = useState( factorySelect ? {
        value: factoryID,
        label: factoryID
    }: null);

    const { REACT_APP_API_BACKEND_URL } = process.env;

    useEffect(() => {
        setSelectedOption({value: factory,
            label: factory});
    }, [factory]);

    useEffect(() => {
        const getFactories = async () => {
            const factoryFromServer = await fetchFactory();
            setFactorySelect(factoryFromServer);
        };

        getFactories();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Fetch Categories
    const fetchFactory = async () => {
        const res = await fetch(
            REACT_APP_API_BACKEND_URL + '/api/grievance/getfactoryAndCategorylist'
        );
        const data = await res.json();

        return data.grievanceFactoryList;
    };

    const options = factorySelect.map((factory, index) => {
        return {
            value: factory.factory,
            label: factory.factory
        }
    })

    const handleChange = (selectedOption) => {
        setSelectedOption(selectedOption);

        if (selectedOption) {
            getFactory(selectedOption.value)
        }
    };

    return (
        <Select
            placeholder={'Select a factory...'}
            components={{ Control: ControlComponent }}
            value={selectedOption}
            onChange={handleChange}
            options={options}
            isClearable
        />
    );
};

export default FactoryDropdown;
